export default __webpack_public_path__ + "static/media/lucent.18998d48.png";